import React, {useEffect, useState} from "react";
import PlotlyPlot from "../../../../common/components/PlotlyPlot";
import {loadProtocolImpedanceData} from "../../services/protocols";
import {PlotParams} from "react-plotly.js";
import {IProtocol} from "../../../types/protocol";
import {ICompany} from "../../../../common/types";
import {Box, Loader} from "@mantine/core";

interface ImpedanceChartProps {
    activeCompany: ICompany;
    selectedProtocol: IProtocol | undefined;
    refreshTrigger?: number;
}

export const ImpedanceChart: React.FC<ImpedanceChartProps> = ({activeCompany, selectedProtocol, refreshTrigger}) => {
    const [plotData, setPlotData] = useState<PlotParams>()
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        if (selectedProtocol) {
            setLoading(true)
            loadProtocolImpedanceData(activeCompany.id, selectedProtocol).then((data) => {
                // Build one trace per channel
                const traceMap: Map<string, { x: string[]; y: number[] }> = new Map()

                data.data.forEach(([time, channelMap]: [string, Record<string, number>]) => {
                    Object.entries(channelMap).forEach(([channel, impedance]) => {
                        if (!traceMap.has(channel)) {
                            traceMap.set(channel, {x: [], y: []})
                        }
                        const trace = traceMap.get(channel)!
                        trace.x.push(time)
                        trace.y.push(impedance)
                    })
                })

                const traceBase = (data.figure.data[0] || {}) as any;
                const traces = Array.from(traceMap.entries()).sort(([a], [b]) => a.localeCompare(b)).map(([channel, {x, y}]) => ({
                    ...traceBase,
                    name: channel,
                    x,
                    y,
                }))

                setPlotData({
                    layout: {
                        ...data.figure.layout,
                    },
                    config: {
                        responsive: true,
                    },
                    data: traces.length > 0 ? traces : data.figure.data,
                })
            }).catch(() => {
                // eat the error since notification would already be called
            }).finally(() => {
                setLoading(false)
            })
        }
    }, [selectedProtocol, refreshTrigger])

    const renderLoading = () => (
        <Box style={{position: "absolute", zIndex: "10", top: "calc(50% - 2em)", left: "calc(50% - 2em)"}}>
            <Loader size="4em" color="var(--bios-strong-accent)"/>
        </Box>
    )

    if (plotData) {
        return (
            <Box>
                <PlotlyPlot {...plotData}/>
                {loading ? renderLoading() : <></>}
            </Box>
        )
    } else {
        return (
            <Box>
                {renderLoading()}
            </Box>
        )
    }
}

